<template>
  <div class="select-policy">
    <NavHeaderBar :navBarTitle="$t('shared.title.selectAPolicy')" />

    <van-sticky :offset-top="46">
      <EventFilter
        :product-options="globalData.brandProductList"
        :objKey="{label: 'productName', value: 'id'}"
        selection-mode="multiple"
        @filter-change="onFilterChange"
      />
    </van-sticky>

    <div class="policy-list">
      <PolicyCard
        v-for="policy in filteredPolicies"
        :key="policy.id"
        :policy="policy"
        :collapsible="true"
        :init-show-rules="false"
        @click="selectPolicy"
      />
      <van-empty v-if="filteredPolicies.length <= 0" :description="$t('tips.noAvailablePolicies')" />
    </div>
  </div>
</template>

<script>
import NavHeaderBar from '@/components/NavHeaderBar'
import PolicyCard from './components/PolicyCard'
import { mapMutations, mapState } from 'vuex'
import { arsEventpolicyListApi } from '@/api/event'
import { Toast } from 'vant'

export default {
  name: 'SelectPolicy',
  components: {
    NavHeaderBar,
    PolicyCard,
    EventFilter: () => import('./components/EventFilter')
  },
  data () {
    return {
      filteredPolicies: [],
      startTime: '',
      endTime: '',
      eventType: ''
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  activated () {
    this.eventType = this.$route.query.eventType || ''
    this.getPolicyData()
  },
  methods: {
    ...mapMutations(['setSelectedPolicy']),
    selectPolicy (policy) {
      this.setSelectedPolicy(policy)
      this.$router.go(-1)
    },
    onFilterChange (data) {
      this.productIdList = data.product
      this.startTime = data.startDate
      this.endTime = data.endDate
      this.getPolicyData()
    },
    getPolicyData () {
      const data = {
        eventType: this.eventType,
        productIdList: this.productIdList,
        startTime: this.startTime,
        endTIme: this.endTime
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsEventpolicyListApi(data).then(res => {
        Toast.clear()
        res.data.forEach(subItem => {
          subItem.newPlanList = []
          subItem.planList.forEach(planItem => {
            // 购买Product A/B 10 Pcs 送 B 2 Pcs
            const productName = planItem.productList.map(nameItem => nameItem.productName).join(' / ')
            const protoName = planItem.protoList.map(nameItem => nameItem.productName).join(' / ')
            subItem.newPlanList.push(`${this.$t('shared.buy')} ${productName} ${planItem.buyCount} ${this.$t('form.pcs')} ${this.$t('shared.get')} ${protoName} ${planItem.giveCount} ${this.$t('form.pcs')}`)
          })
        })
        this.filteredPolicies = res.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.select-policy {
  min-height: 100vh;
  background-color: #f5f5f5;

  .filter-bar {
    position: sticky;
    top: 46px;
    z-index: 99;

    /deep/ .van-dropdown-menu__bar {
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    }
  }

  .policy-list {
    padding: 12px;
  }
}
</style>
